const fn = {
    init: () => {
        if ($('.header-slider__carousel').length) {
            var slideOneCarousel = $('.header-slider__carousel').owlCarousel({
                loop: true,
                items: 1,
                margin: 0,
                dots: true,
                nav: false,
                animateOut: 'slideOutDown',
                animateIn: 'fadeIn',
                active: true,
                smartSpeed: 1000,
                autoplay: 9000,
            });
            $('.slide-one__left-btn').on('click', e => {
                slideOneCarousel.trigger('next.owl.carousel');
                e.preventDefault();
            });
            $('.slide-one__right-btn').on('click', e => {
                slideOneCarousel.trigger('prev.owl.carousel');
                e.preventDefault();
            });
        }
    }
}

export default {
    can: () => $('.header-slider__carousel').length,
    run: fn.init,
};
